export default function MinusAltIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="m16.43,8.57H3.56c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43h12.88c.79,0,1.43-.64,1.43-1.43s-.64-1.43-1.44-1.43Z" />
    </svg>
  )
}
